import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-11">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[75vh] flex flex-col" onClick={e => e.stopPropagation()} data-id="element-12">
        <div className="flex items-center justify-between px-5 py-3 border-b border-gray-200" data-id="element-13">
          <h2 id="modal-title" className="text-lg font-bold text-gray-900" data-id="element-14">
            {title}
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800 transition-colors" aria-label="Close" data-id="element-15">
            <X size={20} data-id="element-16" />
          </button>
        </div>
        <div className="px-5 py-4 overflow-y-auto text-xs text-gray-700 leading-relaxed space-y-3" data-id="element-17">
          {children}
        </div>
      </div>
    </div>;
}